import Tabs, { Tab, TabList } from '@atlaskit/tabs';
import { SelectedType } from '@atlaskit/tabs/types';
import { Box } from '@fuegokit/react';
import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface NumberMap {
  [key: number]: string;
}

const tabPaths: NumberMap = {
  0: '',
  1: 'users',
  2: 'projects',
  3: 'configuration',
};

export function Navigation() {
  const [selected, setSelected] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const loc = location.pathname.slice(1);
    const pathToSelect = Object.values(tabPaths).indexOf(loc);
    if (pathToSelect > -1) {
      setSelected(pathToSelect);
    }
  }, [location]);

  const handleUpdate = useCallback(
    (index: SelectedType) => {
      navigate(tabPaths[index]);
      setSelected(index);
    },
    [setSelected]
  );

  return (
    <Box
      sx={{
        width: '686px',
      }}
    >
      <Tabs onChange={handleUpdate} selected={selected} id="navigation">
        <TabList>
          <Tab>My entries</Tab>
          <Tab>Users</Tab>
          <Tab>Projects</Tab>
          <Tab>Configuration</Tab>
        </TabList>
      </Tabs>
    </Box>
  );
}
